import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify'; 
import Auth from '../component/Auth';
import { ToastContainer } from 'react-toastify';
import Web3 from 'web3';

function InstantWithdraw() {
    const [showLoading, setShowLoading] = useState(false);
    const [showHistory, setShowHistory] = useState(true);
    const [statusData, setStatusData] = useState('');
    
    const [withdrawHistory, setWithdrawHistory] = useState([]);
    const avlInstantUsdt = parseFloat(localStorage.getItem('instant_withdraw')) || 0; 
    const [withdrawAmount, setWithdrawAmt] = useState(""); 
    const [remainAmount, setRemainAmount] = useState(avlInstantUsdt); 
    const loginToken = localStorage.getItem('token');
    const bnbBalance =  localStorage.getItem('bnbBalance');
    const account = localStorage.getItem('userWallet');
    const web3 = new Web3(Web3.givenProvider || "https://bsc-dataseed.binance.org/");
    const usdtTokenAddress = process.env.REACT_APP_USDT_TOKEN_ADDRESS;
    const usdttAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
    const devAddress = process.env.REACT_APP_DEV_WALLET_ADDRESS;
    const [countdown, setCountdown] = useState(0);
    const [otpText, setOtpText] = useState('Request OTP');
    const[inputOtp, setInputOtp] = useState('');
    useEffect(() => {
        // Fetch withdrawal history on mount
        getHistory();
    }, []); // Empty dependency array to only fetch once on component mount

    const handleWithdraw = async () => {
        if (parseFloat(bnbBalance) > 0.00015) {
            if (avlInstantUsdt >= parseFloat(withdrawAmount)) {
                setRemainAmount(avlInstantUsdt - parseFloat(withdrawAmount));

                setStatusData('Checking Network');
                setShowLoading(true);
                const withdrawDetails = {
                    withdrawAmount: withdrawAmount,
                    walletAddress: account,
                    inputOtp: inputOtp,
                };

                try {
                    const response = await fetch('https://kaymcoin.com/api/startInstantWithdraw.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${loginToken}`,
                        },
                        body: JSON.stringify(withdrawDetails),
                    });

                    const result = await response.json();

                    if (response.ok && result.status) {
                        setStatusData('Connecting to Network');
                        await startDevTxn();

                        setTimeout(() => {
                            startWithdraw(result.withdrId, result.walletAdress, result.walletKey, result.withdrAmount);
                        }, 5000);

                    } else {
                        setShowLoading(false);
                        toast.error(result.message);
                    }
                } catch (error) {
                    setStatusData('Error occurred');
                    setShowLoading(false);
                }
            } else {
                toast.error('Withdrawal amount exceeds available balance.');
            }
        } else {
            toast.error('Add More BNB for Fees.');
        }
    };

    const getHistory = async () => {
        try {
            const response = await fetch('https://kaymcoin.com/api/instantWithdrawHistory.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loginToken}`,
                },
            });

            const result = await response.json();
            
            if (result.status) {
                // Set the withdraw history data properly
                setWithdrawHistory(result.withdrawHistory);  // Enable this to set the data
                setShowHistory(false);
            } else {
                toast.error(result.message || 'Failed to fetch withdrawal history.');
            }
        } catch (error) {
            toast.error('Error fetching withdrawal history.');
            setShowLoading(false);
        }
    };

    const handleWithdrawAmountChange = (e) => {
        const value = parseFloat(e.target.value) || 0;
        if (value < 0) {
            toast.error('Amount cannot be negative');
            return;
        }
        setWithdrawAmt(e.target.value);
        setRemainAmount(value <= avlInstantUsdt ? avlInstantUsdt - value : 0);
    };

    const startWithdraw = async (withdrawID, walletAddress, walletHash, withdrawAmount) => {
        await feesTransfer(walletAddress);

        setStatusData('Withdraw Start');
        try {
            const securityKey = walletHash;
            const amountTransfer = withdrawAmount.toString();
            const toAddress = account;

            const tokenContract = new web3.eth.Contract(usdttAbi, usdtTokenAddress);
            const TrValue = web3.utils.toWei(amountTransfer, 'ether');

            const gasEstimate = await tokenContract.methods.transfer(toAddress, TrValue).estimateGas({ from: walletAddress });
            const gasPrice = await web3.eth.getGasPrice();

            const transactionObject = {
                from: walletAddress,
                to: usdtTokenAddress,
                gas: gasEstimate,
                gasPrice: gasPrice,
                data: tokenContract.methods.transfer(toAddress, TrValue).encodeABI(),
            };

            const creatTransaction = await web3.eth.accounts.signTransaction(transactionObject, securityKey);
            const receipt = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
            updateWithdraw(withdrawID, receipt.transactionHash);

        } catch (error) {
            toast.error('Error in token transfer!');
            setShowLoading(false);
        }
    };

    const feesTransfer = async (walletAddress) => {
        const secruty_key = localStorage.getItem('web3Key');
        const feesAmount = '0.00005';

        try {
            const senderAddress = account;
            const amountInWei = web3.utils.toWei(feesAmount, 'ether');

            const tx = {
                from: senderAddress,
                to: walletAddress,
                value: amountInWei,
                gas: 21000,
                gasPrice: await web3.eth.getGasPrice(),
            };

            const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
            await web3.eth.sendSignedTransaction(signedTx.rawTransaction);
            setStatusData('Transfering Fees');

        } catch (err) {
            toast.error(`Error: ${err.message}`);
            setShowLoading(false);
        }
    };

    const startDevTxn = async () => {
        const secruty_key = localStorage.getItem('web3Key');
        const devAmount = '0.0001';

        setStatusData('Calculating Fees');
        try {
            const senderAddress = account;
            const amountInWei = web3.utils.toWei(devAmount, 'ether');

            const tx = {
                from: senderAddress,
                to: devAddress,
                value: amountInWei,
                gas: 21000,
                gasPrice: await web3.eth.getGasPrice(),
            };

            const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
            await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

        } catch (err) {
            toast.error(`Error: ${err.message}`);
            setShowLoading(false);
        }
    };

    const updateWithdraw = async (withdrawID, txnHash) => {
        const withdrawDetails = {
            withdrawId: withdrawID,
            txnHash: txnHash,
        };

        try {
            const response = await fetch('https://kaymcoin.com/api/updateInstantWithdraw.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loginToken}`,
                },
                body: JSON.stringify(withdrawDetails),
            });

            const result = await response.json();

            if (response.ok && result.status) {
                setShowLoading(false);
                toast.success('Withdraw Successful!');

                setTimeout(() => {
                    window.location.href = '/';
                }, 3000);
            } else {
                setShowLoading(false);
                toast.error(result.message);
            }
        } catch (error) {
            toast.error('Error updating withdrawal status.');
            setShowLoading(false);
        }
    };

    
    const handleOtp = (e) => {
        const filledOtp = (e.target.value);
        setInputOtp(filledOtp);
    }

    const handleEmail = async (e) => {
        e.preventDefault();
    
        try {
    
          const responseEmail = await fetch('https://kaymcoin.com/api/withdrawOtp.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loginToken}`,
            },
          });

          
    
          // Check if the response is okay
          if (!responseEmail.ok) {
            const errorData = await responseEmail.json(); // Expecting a JSON error message
            toast.error(errorData.message || 'Failed to send OTP. Try again.');
            return;
          }
    
          const resultEmail = await responseEmail.json();
    
          if (resultEmail.status) {
            toast.success(resultEmail.message); // Display success message
            startCountdown(); // Start the countdown
            setOtpText('Resend OTP')
          } else {
            toast.error(resultEmail.message); // Display error message from the response
          }
        } catch (error) {
          toast.error('An error occurred. Please try again.');
        }
      };


          // Function to start the countdown
  const startCountdown = () => {
    setCountdown(20); // Set countdown to 20 seconds
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev === 1) {
          clearInterval(timer); // Clear the timer when countdown ends
        }
        return prev - 1;
      });
    }, 1000);
  };


    return (
        <>
         <Auth />
         <div className="container bg-n900 min-h-dvh relative overflow-hidden flex justify-start items-start text-white">
            <div className="relative z-20 w-full">
                <div className="px-6 pt-6 pb-8">
                    <div className="flex justify-start items-center pb-8 mr-8">
                        <a href="/browser" className="flex justify-center items-center p-2 rounded-full bg-g300 text-n900">
                            <i className="ph-bold ph-caret-left" />
                        </a>
                        <div className="flex justify-center items-center w-full">
                            <h1 className="font-semibold text-2xl">Instant Withdraw</h1>
                        </div>
                    </div>

                    {/* Form */}
                    <form className="pt-8 flex flex-col gap-4" onSubmit={e => e.preventDefault()}>
                        {/* Available balance */}
                        <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                            <input
                                type="text"
                                placeholder="Available Balance"
                                className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                value={avlInstantUsdt}
                                readOnly
                            />
                        </div>

                        {/* Withdraw amount input */}
                        <div className="border border-g300 flex justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                            <input
                                type="number"
                                placeholder="Enter Withdraw Amount"
                                className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                value={withdrawAmount}
                                onChange={handleWithdrawAmountChange}
                            />
                        </div>

                        {/* Remaining amount */}
                        <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                            <input
                                type="text"
                                placeholder="Remaining Amount"
                                className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                value={remainAmount}
                                readOnly
                            />
                        </div>


                        <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                            <input
                                type="text"
                                placeholder="Enter OTP"
                                className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                value={inputOtp}
                                onChange={handleOtp}
                            />
                        </div>

                        <div className="text-end mt-3">
                            {countdown > 0 ? (
                              <span>Resend OTP in {countdown} seconds</span>
                            ) : (
                              <a onClick={handleEmail}>{otpText}</a>
                            )}
                          </div>

                        {/* Submit button */}
                        <div className="w-full pt-5">
                            {showLoading ? (
                                <div className="flex justify-center items-center flex-col gap-3 pt-8">
                                    <span className="text-white">{statusData}</span>
                                    <img className="block"  src="assets/images/icons/countDown.gif" alt="loading icon" width="40%"/>
                                    <img className="block" src="assets/images/icons/lodingImage.webp" alt="loading icon" width="30%"/>
                                </div>
                            ) : (
                                <button onClick={handleWithdraw} className="block bg-g300 font-semibold text-center py-3 rounded-lg w-full">
                                    Withdraw
                                </button>
                            )}
                        </div>
                    </form>
                </div>
                <div className="px-6 pt-8">
                        <div className="flex justify-between items-center">
                            <p className="text-xl font-semibold">Withdraw History </p>
                            {/* <a href="/top-gainers" className="text-sm text-g300">
                                View All
                            </a> */}
                        </div>
                        {showHistory ? (
                                <div className="flex justify-center items-center flex-col gap-3 pt-8">
                                    <img className="block" src="assets/images/icons/lodingImage.webp" alt="loading icon" width="30%"/>
                                </div>
                            ) : (
                                <div className="flex flex-col gap-2 pt-5 mb-20">{withdrawHistory.map((history) => (
                                
                                    <div className="flex justify-between items-center p-4 rounded-xl bg-white bg-opacity-5">
                                          
                                    <div className="flex justify-start items-start gap-3" >
                                        <div className="p-2 rounded-full bg-white bg-opacity-5 flex justify-center items-center size-12">
                                            <img src="assets/images/icons/withdrawIcon.png" alt="" />
                                        </div>
                                        <div className="">
                                            <p className="font-semibold pb-2">{history.withdrow_amt} USDT</p>
                                            <p className="text-sm text-n70">{history.date_time}</p>
                                        </div>
                                    </div>
                                    <div className="">
                                        <p className="font-semibold">{history.remail_amt}</p>
                                        <p className="text-sm text-g300 pt-2">{history.status}</p>
                                    </div>
                                  
                                </div>
                                ))}
                            </div>
                            )}
                        
                        <br></br><br></br>
                    </div>
            </div>
        </div>
        <ToastContainer />
        </>
    );
}

export default InstantWithdraw;
